export const resetSummaryUrl = (module: string, url: string) => {
  sessionStorage.setItem('summary-url', JSON.stringify({ module, url }));
};

export const getStoredSummaryUrl = (currentModule: string) => {
  const storedString = sessionStorage.getItem('summary-url');
  const { module, url } = storedString ? JSON.parse(storedString) : { module: '', url: '' };
  return !storedString || module !== currentModule ? `/${currentModule}` : url;
};
